module.exports = __webpack_public_path__ + "img/colours-hero.af5fae1a.jpeg";